import { Button } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { InfluencerSignupForm } from '../BuzzBridge/InfluencerSignupForm';
import { useAuth } from '../../module/AuthContext';
import { useDispatch } from 'react-redux';
import { toggleAuthModal } from '../../redux/authentication/action';
import { joinProgram } from '../../redux/buzzbridge/actions';
import { getGlobalConfig } from '../../redux/configuration/action';

interface IJoinBuzzBridgeProgramButton {
    gradients: any;
}
export const JoinBuzzBridgeProgramButton: React.FC<IJoinBuzzBridgeProgramButton> = ({ gradients }): JSX.Element => {
    const [open, setOpen] = useState(false);

    const { isSignedIn } = useAuth();
    const dispatch = useDispatch();

    const handleToggleForm = useCallback(() => {
        setOpen(!open);
    }, [open]);
    const handleJoinProgram = useCallback(() => {
        if (isSignedIn) {
            handleToggleForm();
        } else {
            dispatch(toggleAuthModal(true));
        }
        dispatch(getGlobalConfig());
    }, [isSignedIn, dispatch, handleToggleForm]);

    const handleSubmit = (payload: any) => {
        dispatch(joinProgram(payload));
    };

    return (
        <>
            <InfluencerSignupForm
                open={open}
                onClose={() => setOpen(!open)}
                gradients={gradients}
                onSubmit={handleSubmit}
            />
            <Button
                onClick={handleJoinProgram}
                variant="contained"
                sx={{
                    mt: 4,
                    borderRadius: 50,
                    px: 6,
                    py: 1.5,
                    fontWeight: 600,
                    fontSize: 16,
                    background: `linear-gradient(135deg, ${gradients[0][0]} 0%, ${gradients[0][1]} 100%)`,
                    color: '#fff',
                    boxShadow: '0 8px 20px rgba(102,126,234,0.3)',
                    '&:hover': {
                        background: `linear-gradient(135deg, ${gradients[0][0]} 0%, ${gradients[0][1]} 100%)`,
                    },
                    cursor: 'pointer',
                }}>
                Join Program
            </Button>
        </>
    );
};
